export enum SubmissionTypeEnum {
  MdrCreateNewDeviceModel = 1,
  MdrAddDevicesToRegisteredModel,
  MdrUpdateDevice,
  MdrUpdateModel,
  Draft,
  Submit,
  SearchTheModel,
  GUDIDSubmission,
  AusUDIDSubmission,
  MDRarketInfoUpdate,
  FDASubmission,
  BrazilUDIDSubmission,
  CreateUpdateModelAndDevice = 15
}



